import { LinkBtn, PrimaryBtn } from "../buttons"
import UsageBadge from "./usage-badge"
import { MAX_DREAM_RATE_COUNT } from "../../constants/dream-rate"

interface Props {
  onLearnHowItWorks: () => void
  onNewRateDrop: () => void
}

const DreamRateEmptyState = ({ onLearnHowItWorks, onNewRateDrop }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      <div className="flex flex-col items-center gap-4">
        <UsageBadge count={0} max={MAX_DREAM_RATE_COUNT} />
        <h3 className="text-xl font-extrabold">
          No dream rates yet. Add your first one.
        </h3>
      </div>
      <p className="text-center max-w-80 mt-2">
        <LinkBtn text="base" paddingOff onClick={onLearnHowItWorks}>
          Watch this video
        </LinkBtn>{" "}
        to learn about this feature or email{" "}
        <a href="mailto:support@bankingbridge.com" className="underline">
          support@bankingbridge.com
        </a>
      </p>
      <PrimaryBtn onClick={onNewRateDrop} className="w-52 mt-6">
        Add new dream rate
      </PrimaryBtn>
    </div>
  )
}

export default DreamRateEmptyState
